import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import Vant from 'vant'
import 'ant-design-vue/dist/antd.less'; // install less 5.0.0
import localization, { LanguageInfo } from "./localization"; 
import './styles/override.css';
import 'vant/lib/index.css';
import '@/assets/css/theme.css'
import '@/assets/css/theme-dark.css'

//https://www.andiamo.co.uk/resources/iso-language-codes/
const localizationInfo = {
    localMessageResourcePath : 'language',
    languages: [ 
      new LanguageInfo("en",    "English", "en.json",  true), 
      new LanguageInfo("zh-tw", "Chinese(Taiwan)", "zh-hant.json"), 
      new LanguageInfo("zh-hk", "Chinese(Hong Kong)", "zh-hant.json"), 
      new LanguageInfo("zh-mo", "Chinese(Macro)",  "zh-hant.json"), 
      new LanguageInfo("zh-cn", "Chinese(PRC)",    "zh-hans.json"), 
      new LanguageInfo("zh-sg", "Chinese(Singapore)",    "zh-hans.json"), 
      new LanguageInfo("zh-chs", "简体中文",   "zh-hans.json"), 
      new LanguageInfo("zh-cht", "繁體中文",   "zh-hant.json"), 
      new LanguageInfo("zh-hans", "简体中文",  "zh-hans.json"), 
      new LanguageInfo("zh-hant", "繁體中文",  "zh-hant.json"), 
    ] ,
  }

const app = createApp(App).use(store).use(router).use(Antd).use(Vant).use(localization, localizationInfo)
app.mount('#app')